import { ENDPOINTS } from "../../constant/routes";
import { request } from "../../services/requests";

export interface AcronymGroup {
  id: string;
  terms: string[];
}

export interface SearchPreviewItem {
  listing_id: string;
  name: string;
  genus: string | null;
}

export interface SearchPreview {
  total: number;
  results: SearchPreviewItem[];
}

export const listAcronymGroups = (token: string) =>
  request(token).get<AcronymGroup[]>(ENDPOINTS.SEARCH_ACRONYMS);

export const saveAcronymGroup = (id: string, terms: string[], token: string) =>
  request(token).put<AcronymGroup>(
    `${ENDPOINTS.SEARCH_ACRONYMS}/${encodeURIComponent(id)}`,
    { terms },
  );

export const deleteAcronymGroup = (id: string, token: string) =>
  request(token).delete(`${ENDPOINTS.SEARCH_ACRONYMS}/${encodeURIComponent(id)}`);

export const previewSearch = (query: string, token: string) =>
  request(token).get<SearchPreview>(`${ENDPOINTS.SEARCH_ACRONYMS}/preview`, {
    params: { q: query },
  });
